var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOracle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EA1B22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13.2H13C10.349 13.2 8.2 15.349 8.2 18C8.2 20.651 10.349 22.8 13 22.8H23C25.651 22.8 27.8 20.651 27.8 18C27.8 15.349 25.651 13.2 23 13.2ZM13 10C8.58172 10 5 13.5817 5 18C5 22.4183 8.58172 26 13 26H23C27.4183 26 31 22.4183 31 18C31 13.5817 27.4183 10 23 10H13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOracle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/oracle.a4916f72fa210b6743ae24bc3f13209d.svg";